import { memo } from "react";
import { PageHeader, useTheme } from "react-better-html";

import { useI18n } from "../../utils/i18n";

function Notifications() {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <>
         <PageHeader title={t((l) => l.pages.notifications.title)} titleAs="h2" marginBottom={theme.styles.space} />
      </>
   );
}

export default memo(Notifications);
